export default function Loading() {
    return (
        <div className="loading">
            <p>Ładowanie...</p>
        </div>
    )
};